module.exports = __webpack_public_path__ + "static/img/newsDetailPic4.e37fac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic4.png
// module id = hWJk
// module chunks = 1